/**
 * Created by frank.law on 11/21/17.
 */
import React from 'react';
import '../../../css/login.css';
import {connect} from 'react-redux';
import PasswordField from '../formFields/PasswordField';
import FieldError from '../formFields/FieldError';
import {LocalForm} from 'react-redux-form';
import {newPasswordOnChange, confirmPasswordOnChange, submitResetPasswordChallenge} from '../../actions/actions';
import PropTypes from 'prop-types';
import LoginUtils from '../../utils/LoginUtils';

class PasswordConfirmationForm extends React.Component {

    handleSubmit(formValues) {
        const { submitResetPasswordChallenge, token, challenge} = this.props;
        submitResetPasswordChallenge(formValues.new_password_field_1, formValues.confirm_password_field_1, token, challenge);
    }

    render() {

        const { title,
                passwordError,
                passwordLabel,
                passwordPlaceholder,
                passwordConfirmationLabel,
                passwordConfirmationPlaceholder,
                newPasswordOnChange,
                newPasswordFieldValue,
                confirmPasswordOnChange,
                confirmPasswordFieldValue,
                submitLabel} = this.props;

        let errorField = [];
        if (passwordError) {
            errorField = (<FieldError errorText={passwordError}/>);
        }

        return (
            <div key="PasswordForm_1">
                <LocalForm model="loginForm" className="login-form" onSubmit={(formValues) => this.handleSubmit(formValues)}>
                    <h4>{title}</h4>
                    <PasswordField label={passwordLabel} placeholder={passwordPlaceholder} onChangeFunc={newPasswordOnChange} fieldId="new_password_field_1" autoFocus={true}/>
                    <PasswordField label={passwordConfirmationLabel} placeholder={passwordConfirmationPlaceholder} onChangeFunc={confirmPasswordOnChange}  fieldId="confirm_password_field_1"/>
                    {errorField}
                    <button className="wdc-btn wdc-btn-primary" disabled={!LoginUtils.checkPasswordsMatch(newPasswordFieldValue, confirmPasswordFieldValue)}>{submitLabel}</button>
                </LocalForm>
            </div>
        );
    }
}

PasswordConfirmationForm.propTypes = {
    title: PropTypes.string,
    usernameError: PropTypes.string,
    newPasswordOnChange: PropTypes.func,
    newPasswordFieldValue: PropTypes.string,
    confirmPasswordOnChange: PropTypes.func,
    confirmPasswordFieldValue: PropTypes.string,
    passwordLabel: PropTypes.string,
    passwordPlaceholder: PropTypes.string,
    passwordConfirmationLabel: PropTypes.string,
    passwordConfirmationPlaceholder: PropTypes.string,
    submitLabel: PropTypes.string,
    token: PropTypes.string,
    challenge: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        passwordError: state.login.errorText,
        newPasswordFieldValue: state.forms.newPassword,
        confirmPasswordFieldValue: state.forms.confirmPassword,
        failedAuth: state.login.failedAuth,
        token: state.login.token,
        title: state.login.challengeResponse.title,
        passwordLabel: state.login.challengeResponse.prompts.password.label,
        passwordPlaceholder: state.login.challengeResponse.prompts.password.placeholder,
        passwordConfirmationLabel: state.login.challengeResponse.prompts.passwordAgain.label,
        passwordConfirmationPlaceholder: state.login.challengeResponse.prompts.passwordAgain.placeholder,
        submitLabel: state.login.challengeResponse.submitLabel,
        challenge: state.login.challengeResponse.nextChallenge
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        newPasswordOnChange: (newValue) => {
            dispatch(newPasswordOnChange(newValue))
        },
        confirmPasswordOnChange: (newValue) => {
            dispatch(confirmPasswordOnChange(newValue))
        },
        submitResetPasswordChallenge: (newPassword, newPasswordConfirmation, token, challenge) => {
            dispatch(submitResetPasswordChallenge(newPassword, newPasswordConfirmation, token, challenge));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordConfirmationForm);
